import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { useBranchList } from './hooks';
import { convertToBranchListProps } from './logics';
import { BranchListPresentation } from './presentations';

export const BranchList: React.FC = () => {
  const {
    state: { data, currentPage, totalPage, totalCount },
    actions: { handlePageChange, handleEditBranch, handleDeleteBranch },
  } = useBranchList();

  const { branches } = convertToBranchListProps({ data });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows: branches,
    onPageChange: handlePageChange,
  });

  return (
    <BranchListPresentation
      branches={branches}
      pagerProps={pagerProps}
      handleEdit={handleEditBranch}
      handleDelete={handleDeleteBranch}
    />
  );
};
